// app/middleware/auth.global.ts

export default defineNuxtRouteMiddleware(async (to) => {
    const { loggedIn, user, clear } = useUserSession()

    if (loggedIn.value && user.value?.status !== "active") {
        const reason = user.value?.status ?? "blocked"
        await clear()
        return navigateTo({ path: "/login", query: { reason } })
    }

    if (!loggedIn.value && to.path === "/home") {
        return navigateTo("/login")
    }

    if (loggedIn.value && to.path === "/login") {
        return navigateTo("/home")
    }
})
